import { Injectable, Type } from '@angular/core';
import { PopupComponent } from '../components/popup/popup.component';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { isNull } from 'util';
import { LoggerService } from 'angular-lib';

@Injectable()
export class PopupService {
    private type: Type<PopupComponent>;
    private active: boolean = false;
    private subject: Subject<any>;
    private data: any;
    private feedback: boolean;

    /**
     * Show the popup
     * @param {Type<PopupComponent>} type Popup component type to display
     * @param data data to passes to the popup component
     * @returns {Observable<Object>} observable to subscribe to get response
     */
    public showPopup(type: Type<PopupComponent>, data?: any): Observable<any> {
        // need to initialize subject here to subscribe to every opened popup
        this.subject = new Subject<any>();
        this.type = type;
        this.active = true;
        this.feedback = false;
        this.data = data;
        LoggerService.info('POPUP DISPLAYED : ' + type.name);
        return this.subject.asObservable();
    }

    /**
     * Close the popup
     */
    public close(): void {
        this.active = false;
        this.subject.complete();
        LoggerService.info('POPUP CLOSED');
    }

    public accept(data): void {
        LoggerService.info('POPUP ACCEPTED');
        this.subject.next(data);
    }

    /**
     * Return data sent to the popup
     * @returns {Object}
     */
    public getData(index?: string): any {
        // if we got an index, return data[index] if exists
        if (typeof index !== 'undefined' && this.hasData(index)) {
            return this.data[index];
            // if we don't have index, return data if exists
        } else if (typeof index === 'undefined' && this.hasData()) {
            return this.data;
        }

        // otherwise return null
        return null;
    }

    public hasData(index?: string): boolean {
        // if we don't have any data, no need to go further, return false
        if (typeof this.data === 'undefined' || isNull(this.data)) {
            return false;
        }
        // if no index has been specified, check we have some data
        if (typeof index === 'undefined') {
            return Object.keys(this.data).length !== 0;
            // if we have an index and data is not empty, check if data has index 'index'
        } else if (index !== '' && this.data.hasOwnProperty(index)) {
            return true;
        }

        // otherwise return false
        return false;
    }


    public showFeedBack(show: boolean = false) {
        LoggerService.info('POPUP FEEDBACK SHOWED');
        this.feedback = show;
    }

    public destroyPopup() {
        this.type = null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/services/popup.service.ts